import { Component, inject, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService } from '@core/theme/theme.service';

@Component({
  selector: 'app-theme-toggle',
  imports: [MatIconModule],
  templateUrl: './theme-toggle.html',
  styleUrl: './theme-toggle.scss',
})
export class ThemeToggle {
  private readonly theme = inject(ThemeService);
  readonly selectedTheme = computed(() => this.theme.theme());

  /** Resolved, so from "auto" the toggle moves away from what the OS shows. */
  readonly isDarkMode = this.theme.isDarkMode;

  toggleTheme(): void {
    this.theme.setTheme(this.isDarkMode() ? 'light' : 'dark');
  }
}
